export default {
    padding: '10px 0 20px',
}